import { useLingui } from "@lingui/react";
import { CheckoutSettings } from "@paddle/paddle-js/types/checkout/checkout";
import { IApiEpBillingBill, IApiEpBillingRecurringPayment } from "@smp/api";
import { clsx } from "clsx";
import { useCallback, useRef } from "react";
import { useUpdateEffect } from "react-use";

import { usePaddle } from "@/hooks/use_paddle";
import { pickPaddleLocale } from "@/utils";

import classes from "./paddle.module.css";

const CONTAINER_CLASS = "ep-paddle-container";

export const Paddle = ({
  bill,
  recurringPayment,
  onClose,
}: {
  bill?: IApiEpBillingBill;
  recurringPayment?: IApiEpBillingRecurringPayment;
  onClose: (fireSuccessAction?: boolean) => void;
}) => {
  const {
    i18n: { locale },
  } = useLingui();

  const $container = useRef<HTMLDivElement | null>(null);

  const eventListener = useCallback<
    NonNullable<Parameters<typeof usePaddle>[0]>
  >(
    (event) => {
      if (event.name === "checkout.completed") {
        onClose(true);
      }
    },
    [onClose],
  );

  const paddle = usePaddle(eventListener);

  useUpdateEffect(() => {
    if (paddle && $container.current) {
      const settings: CheckoutSettings = {
        variant: "one-page",
        displayMode: "inline",
        frameTarget: $container.current.classList.toString(),
        frameStyle: " ",
        locale: pickPaddleLocale(locale),
      };

      if (
        recurringPayment?.confirm_widget_args?.items &&
        recurringPayment?.confirm_widget_args?.customer &&
        recurringPayment?.confirm_widget_args?.customData
      ) {
        paddle.Checkout.open({
          items: recurringPayment.confirm_widget_args.items,
          customer: recurringPayment.confirm_widget_args.customer,
          customData: recurringPayment.confirm_widget_args.customData,
          settings,
        });
      } else if (bill?.extra.paddle_widget_args) {
        paddle.Checkout.open({
          ...bill.extra.paddle_widget_args,
          settings,
        });
      } else {
        onClose(false);
      }
    }
  }, [paddle]);

  return (
    <div
      className={clsx(CONTAINER_CLASS, classes.container)}
      ref={$container}
    />
  );
};
